import { TweenLite, Power0, Power2, Power3 } from 'gsap'
import TimelineMax from 'gsap/TimelineMax'
import '../lib/DrawSVGPlugin'
import { bindInViewTimeline } from '../util/animations'

class ScrollTopButton {
  constructor ($el) {
    this.$el = $el
    this.timelineIn = new TimelineMax({
      paused: true,
      delay: 1,
    })
    this.buildTimelineIn()
    bindInViewTimeline($el, this.timelineIn)
    $el.click(this.scrollToTop)
    $el.hover(
      () => {
        TweenLite.to(
          $el.find('path'),
          0.2,
          { stroke: '#ffffff', ease: Power0.easeNone }
        )
      },
      () => {
        TweenLite.to(
          $el.find('path'),
          0.2,
          { stroke: '#7C634B', ease: Power0.easeNone }
        )
      }
    )
  }

  scrollToTop () {
    TweenLite.to($(window), 0.6, {
      scrollTo: 0,
      ease: Power2.easeInOut,
    })
  }

  buildTimelineIn () {
    const $el = this.$el
    this.timelineIn
      .fromTo(
        $el.find('path'),
        0.6,
        { drawSVG: '0%', stroke: '#ffffff' },
        { drawSVG: '100%', stroke: '#7C634B', ease: Power3.easeInOut }
      )
      .fromTo(
        $el.find('span'),
        0.3,
        { autoAlpha: 0 },
        { autoAlpha: 1, ease: Power0.easeNone }
      )
  }
}

export default ScrollTopButton



// WEBPACK FOOTER //
// ./scripts/components/ScrollTopButton.js